<template>
	<section ref="sectionBlockquote"
			 class="flex-module container-fluid flexible-blockquote">
		<div class="row">
			<div ref="blockquote"
				 class="col-xs-12">
				<BaseBlockquote :data="data.item"
								class="base-block" />
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	data: {
		type: Object,
		required: true
	}
})

const { gsap, SplitText } = useGsap()

const sectionBlockquote = ref(null)

let $q

function animShowQuote() {
	const text = $q('.up-text')
	const icon = $q('.icon')
	const source = $q('.quote-source')

	const innerSplit = new SplitText(text, {
		type: 'lines',
		linesClass: 'split_inner'
	})
	const outerSplit = new SplitText(text, {
		type: 'lines',
		linesClass: 'split_outer'
	})

	triggers.splitTimeline = gsap.timeline({
		scrollTrigger: {
			id: 'splitTimeline',
			trigger: text,
			start: 'top 80%',
			end: 'bottom 0%',
		},
		onComplete: () => {
			outerSplit.revert()
			innerSplit.revert()
		}
	})

	source.length && gsap.set(icon, { yPercent: -50 })
	// gsap.set(source, { xPercent: 0 })

	triggers.splitTimeline
		.from(innerSplit.lines, {
			duration: 1.25,
			yPercent: 150,
			autoAlpha: 0,
			ease: 'expo.out',
			stagger: 0.075,
		})


	if (source.length) {
		triggers.splitTimeline
			.from(icon, {
				scale: 0,
				duration: 0.5,
				// autoAlpha: 0,
				ease: 'expo.out'
			}, '-=0.6')
			.from(source, {
				x: -15,
				autoAlpha: 0,
				duration: 0.7,
				ease: 'circ.out'
			}, '-=0.4')
	}
}

const triggers = {}
function initAnims() {
	$q = gsap.utils.selector(sectionBlockquote.value)
	animShowQuote()
}

onMounted(() => {
	useAnims(initAnims, triggers)
})
</script>


<style lang="scss" scoped>
.base-block {
	width: 90%;
	max-width: rem-calc(900);
	margin: auto;
	text-align: center;
}



:deep(figure) {
	blockquote {
		@include textH5;
	}

	figcaption {
		display: inline-block;
		position: relative;
		@include textBody;
		color: var(--details-color, $colorRed);
		margin-top: rem-calc(25);
		padding-left: rem-calc(30);

		.icon {
			position: absolute;
			top: calc(50% + 2px);
			transform: translateY(-50%);
			left: 0;
			width: rem-calc(15);
			height: rem-calc(15);

			svg {
				display: block;
			}
		}

		.quote-person,
		.quote-org {
			display: inline-block;
		}

		.quote-org {
			font-weight: 700;
		}
	}
}
</style>
